
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!registration.login";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/registration/jst/login';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;


  buffer += "<form method=\"post\" action=\"/login/canvas\" id=\"login_form\" class=\"bootstrap-form\">\n  <input type=\"hidden\" name=\"redirect_to_ssl\" value=\"1\"/>\n  <input type=\"hidden\" name=\"_method\" value=\"POST\">\n  <input name=\"authenticity_token\" type=\"hidden\" value=\"";
  if (helper = helpers.auth_token) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.auth_token); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n  <div>\n    <input name=\"pseudonym_session[unique_id]\" class=\"login-input\" type=\"text\" placeholder=\"";
  if (helper = helpers.login_handle_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.login_handle_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n  </div>\n  <div>\n    <input name=\"pseudonym_session[password]\" class=\"login-input\" type=\"password\" placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("registration.login")
  },data:data},helper ? helper.call(depth0, "password", "Password", options) : helperMissing.call(depth0, "t", "password", "Password", options)))
    + "\">\n  </div>\n  <div>\n    <button type=\"submit\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("registration.login")
  },data:data},helper ? helper.call(depth0, "sign_in", "Sign In", options) : helperMissing.call(depth0, "t", "sign_in", "Sign In", options)))
    + "</button>\n  </div>\n  <label class=\"checkbox\">\n    <input name=\"pseudonym_session[remember_me]\" type=\"checkbox\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("registration.login")
  },data:data},helper ? helper.call(depth0, "remember_me", "Remember Me", options) : helperMissing.call(depth0, "t", "remember_me", "Remember Me", options)))
    + "\n  </label>\n</form>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  